<div class="component-container">
  <div fxLayout="row" class="pt-1" fxLayoutAlign="space-between center">
    <button mat-button (click)="goBack()" color="primary" fxFlex="5">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
    <div fxFlex="grow" fxFlexAlign="center" class="admin-page-title">
      {{ newAgency ? 'Create Agency' : 'Edit Agency' }}
    </div>
    <div fxFlex="5"></div>
  </div>
  <div fxLayout="column wrap" fxLayoutAlign="space-around stretch">
    <mat-card class="my-1 agency-info-card" fxFlexAlign="center">
      <mat-card-content>
        <form #agencyForm="ngForm" fxLayout="column">
          <mat-form-field>
            <input
              matInput
              #name="ngModel"
              placeholder="Name"
              [(ngModel)]="data.name"
              name="name"
              autocomplete="name"
              required
            />
            <mat-error *ngIf="name.invalid && (name.dirty || name.touched)">
              <div *ngIf="name?.errors.required">Name is required</div>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <input
              matInput
              #companyStreet="ngModel"
              placeholder="Street Address"
              [(ngModel)]="data.street"
              name="companyStreet"
              autocomplete="address-line1"
              required
            />
            <mat-error *ngIf="companyStreet.invalid && (companyStreet.dirty || companyStreet.touched)">
              <div *ngIf="companyStreet?.errors.required">Street Address is required</div>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <input
              matInput
              #companyStreet2="ngModel"
              placeholder="Address Line 2"
              [(ngModel)]="data.street2"
              name="companyStreet2"
              autocomplete="address-line2"
            />
          </mat-form-field>

          <div fxLayout="row wrap" fxLayoutAlign="space-between">
            <div fxFlex="45">
              <mat-form-field class="full-width">
                <input
                  matInput
                  #companyCity="ngModel"
                  placeholder="City"
                  [(ngModel)]="data.city"
                  name="companyCity"
                  autocomplete="address-level2"
                  required
                />
                <mat-error *ngIf="companyCity.invalid && (companyCity.dirty || companyCity.touched)">
                  <div *ngIf="companyCity?.errors.required">City is required</div>
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="15">
              <mat-form-field class="full-width">
                <input
                  matInput
                  #companyState="ngModel"
                  placeholder="State"
                  [(ngModel)]="data.state"
                  name="companyState"
                  autocomplete="address-level1"
                  required
                />
                <mat-error *ngIf="companyState.invalid && (companyState.dirty || companyState.touched)">
                  <div *ngIf="companyState?.errors.required">State is required</div>
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field class="full-width">
                <input
                  matInput
                  #companyZip="ngModel"
                  placeholder="Zip Code"
                  [(ngModel)]="data.zip"
                  name="companyZip"
                  autocomplete="postal-code"
                  mask="00000"
                  required
                />
                <mat-error *ngIf="companyZip.invalid && (companyZip.dirty || companyZip.touched)">
                  <div *ngIf="companyZip?.errors.required">Zip Code is required.</div>
                  <div *ngIf="companyZip?.errors.pattern">Enter a valid Zip Code.</div>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-form-field>
            <input
              matInput
              type="tel"
              #phone="ngModel"
              placeholder="Phone Number"
              [(ngModel)]="data.phone"
              name="phone"
              autocomplete="phone-number"
              mask="(000) 000-0000"
              [showMaskTyped]="true"
              required
            />
            <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">
              <div *ngIf="phone?.errors.required">Phone Number is required</div>
              <div *ngIf="phone?.errors.pattern">Not enough digits</div>
            </mat-error>
          </mat-form-field>
        </form>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-button *ngIf="newAgency" [disabled]="loading" (click)="cancelCreate()">Cancel</button>
        <button
          mat-raised-button
          [appShowSpinner]="loading"
          [buttonText]="newAgency ? 'Create Agency' : 'Save'"
          color="primary"
          [disabled]="disableSubmit(agencyForm)"
          (click)="saveAgency()"
        >
          {{ newAgency ? 'Create Agency' : 'Save' }}
        </button>
      </mat-card-actions>
    </mat-card>

    <div
      *ngIf="!newAgency && agency.advertisers.length >= 0"
      fxLayout="row"
      class="consistent-page-heading"
      fxLayoutAlign="start center"
    >
      <div fxFlex="grow" fxFlexAlign="center">Advertisers</div>
    </div>
    <div *ngIf="!newAgency && agency.advertisers.length > 0" class="full-height mb-2">
      <!--prettier-ignore-->
      <mat-table #table [dataSource]="dataSource" class="mat-elevation-z2">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Advertiser Name</mat-header-cell>
          <mat-cell *matCellDef="let adv">{{adv.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let adv">
            <button color="accent" mat-stroked-button (click)="editAdv(adv.id)">Edit</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    <div *ngIf="!newAgency && data.advertisers.length === 0" class="text-center">
      No Advertisers Found
    </div>
  </div>
</div>
